import {Col} from "react-bootstrap";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    IMG_PRODUCTS_PUBLIC_URL_SERVER, PUBLIC_URL_SERVER
} from "../../../../apis";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import imgPlayS from "../../../../images/base-image-product.jpg";


import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
import {useHistory} from "react-router-dom";

const CardFoodPackage = (props) => {
    const dispatch = useDispatch();

    const foodPack = props.package;

    const {token} = useSelector(state => state.user);
    let history = useHistory();
    const openModalPackDetails = () => {
        if (token) {
            
            history.push(`/food-package/${foodPack.id}`);
        } else {
            /*swal({
                title: "ورود به سایت",
                text: "لطفا ابتدا در سایت وارد شدید",
                buttons: {
                    cancel: "انصراف",
                    confirm: {
                        text: 'ورود',
                        value: "ok",
                    },
                },
                icon: "info",
            }).then((value) => {
                if (value === 'ok') {*/
            dispatch(handelOpenModalLoginAndRegister());
            /* }
         });*/
        }
    };


    return (
        <Col xs={12} md={6} lg={4} key={foodPack.id} className='mb-3 mb-lg-0' style={{minWidth: "100%"}} >
            <div
                // className={`card-store-page-stores m-lg-2  ${loaderSelectedMarket === market.id ? ' card-store-page-stores-click' : null}`}
                className={`card-store-page-stores card-foodpack-page-stores m-lg-2`}
                onClick={openModalPackDetails}
                >
                
                <div className='text-center'>
                    <LazyLoadImage
                        alt='سالاد سزار'
                        src={PUBLIC_URL_SERVER + IMG_PRODUCTS_PUBLIC_URL_SERVER + foodPack.image}
                        width={85}
                        height={85}
                        placeholderSrc={imgPlayS}
                    />
                </div>
                <div className='box-titles-card-store-page-stores'>
                    <h6 className={'title-txt-item-select-base-market title-food-pack'}>{foodPack.name}</h6>
                    <p className={'time-send-item-select-base-market m-0'}>{foodPack.grade_title}</p>
                    <p className={'time-send-item-select-base-market m-0'}>{foodPack.unit}</p>
                </div>
            </div>
        </Col>
    );
};

export default CardFoodPackage;
